import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import "./css/font.css";

import * as serviceWorker from "./serviceWorker";
import Isshoikka from "./isshoikka";

ReactDOM.render(
    <React.StrictMode>
        <Isshoikka />
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
